<article
    #cardContainer
    [id]="id + '.article'"
    class="agpr-mention"
    [attr.data-mention-id]="mention.mentionId"
    [attr.data-mercury-id]="mention.id"
    [@showMoreContent]="{value: expanded ? 'expanded' : 'collapsed', params: {collapsedHeight}}"
    (@showMoreContent.done)="contentVisible = expanded"
>
    <div class="agpr-mention-main">
        <div
            class="agpr-mention-main-firstRow"
            [ngClass]="{'agpr-mention-main-firstRow--compact': !contentVisible && _compact}"
        >
            <div class="agpr-mention-main-firstRow-content">
                @if (!mention?.translating && (
                    (mention?.showTranslated && mention?.translation) ||
                    (mention?.translation?.failedToTranslate) ||
                    (mention?.isTranslatedPreferred && mention?.translation))
                ) {
                    <div class="agpr-mention-showTranslated">
                        <agpr-mention-language-display
                            [mention]="mention"
                            [showLanguageLabel]="true"
                        ></agpr-mention-language-display>
                    </div>
                }

                <div class="agpr-mention-headline">
                    @if (mention.isLexisNexis) {
                        <img
                            src="assets/images/lexisNexisIcon.png"
                            [alt]="'MediaType.lexisNexis.logo' | localize"
                            class="agpr-mention-mediaTypeIcon agpr-mention-mediaTypeIcon--lexisNexis"
                            agprTooltip="MediaType.lexisNexis"
                            tooltipPosition="left"
                        />
                    }
                    @if (mention.isBurrelles) {
                        <img
                            src="assets/images/burrellesIconUpdate.png"
                            [alt]="'MediaType.burrelles.logo' | localize"
                            class="agpr-mention-mediaTypeIcon agpr-mention-mediaTypeIcon--burrelles"
                            agprTooltip="MediaType.burrelles"
                            tooltipPosition="left"
                        />
                    }
                    @if (mention.isCla) {
                        <img
                            src="assets/images/cla.jpg"
                            [alt]="'MediaType.cla.logo' | localize"
                            class="agpr-mention-mediaTypeIcon agpr-mention-mediaTypeIcon--cla"
                            agprTooltip="MediaType.cla"
                            tooltipPosition="left"
                        />
                    }
                    @if (mention.isNla) {
                        <img
                            src="assets/images/nla.jpg"
                            [alt]="'MediaType.nla.logo' | localize"
                            class="agpr-mention-mediaTypeIcon agpr-mention-mediaTypeIcon--nla"
                            agprTooltip="MediaType.nla"
                            tooltipPosition="left"
                        />
                    }
                    <span>
                        @if (mention.tvEyesPodcastID) {
                            <agpr-button
                                class="agpr-mention-link"
                                [style]="buttonTypes.link"
                                (click)="openTvEyesPodcastPlayer()"
                            >
                                <ng-container [ngTemplateOutlet]="headlineContent"></ng-container>
                            </agpr-button>
                        } @else if (isTVEyes) {
                            <agpr-button
                                class="agpr-mention-link"
                                [style]="buttonTypes.link"
                                (click)="openTVEyesDialog()"
                            >
                                <ng-container [ngTemplateOutlet]="headlineContent"></ng-container>
                            </agpr-button>
                        } @else if (mention.url && canLinkOut) {
                            <a
                                [href]="mention.url"
                                target="_blank"
                                class="agpr-mention-link"
                                [id]="id + '.sourceLink'"
                            >
                                <ng-container [ngTemplateOutlet]="headlineContent"></ng-container>
                            </a>
                        } @else {
                            <ng-container [ngTemplateOutlet]="headlineContent"></ng-container>
                        }
                        @if ((mention.isCla || mention.isNla) && !mention.url) {
                            <span
                                class="fa-solid fa-key agpr-mention-mentionLockIcon"
                                [agprTooltip]="'Mention.tooltip.unlock' | localize:{ licenseType: mention.isCla ? 'CLA' : 'NLA' }"
                                (click)="$event.stopPropagation(); unlockMentionClicked.emit()"
                            ></span>
                        }
                    </span>

                    <ng-template #headlineContent>
                        @if ((mention?.showTranslated || mention?.isTranslatedPreferred) && mention?.translation?.headline) {
                            <span
                                class="agpr-mention-headlineValue"
                                dir="auto"
                                [innerHTML]="mention?.translation?.headline | indexHighlight:mention?.translation?.headlineHighlightIndexes : highlightKeywords | indexHighlightSup"
                            ></span>
                        } @else if (mention.headline) {
                            <span
                                class="agpr-mention-headlineValue"
                                dir="auto"
                                [innerHTML]="mention.headline | highlightKeywords:highlightKeywords"
                            ></span>
                        } @else {
                            <span class="agpr-mention-headlineValue">{{ mention.mediaType.noHeadlineMessage | localize }}</span>
                        }
                    </ng-template>
                </div>

                <div class="agpr-mention-main-firstRow-outletAuthorContainer">
                    <div class="agpr-mention-main-outlet">
                        @if (mention.publication?.name) {
                            @if (isLegacyTargetingUser) {
                                @if (mention.publication.outletUrl) {
                                    <a
                                        class="agpr-mention-link"
                                        [id]="id + '.publicationLink'"
                                        [href]="mention.publication.outletUrl"
                                        target="_blank"
                                    >
                                        <span>{{ mention.publication?.name }}</span>
                                    </a>
                                } @else {
                                    <span>{{ mention.publication?.name }}</span>
                                }
                            } @else {
                                @if (mention.publication?.uuid) {
                                    <agpr-button
                                        [style]="buttonTypes.link"
                                        class="agpr-mention-link agpr-mention-link-profile"
                                        [id]="id + '.publicationLink'"
                                        (click)="outletClicked.emit()"
                                        tooltip="Mention.tooltip.outlet"
                                        tooltipPosition="top"
                                    >
                                        <ng-container [ngTemplateOutlet]="pubName"></ng-container>
                                    </agpr-button>
                                } @else {
                                    <ng-container [ngTemplateOutlet]="pubName"></ng-container>
                                }
                                <ng-template #pubName>
                                    <!-- please do not change the indent here, it would add an empty space -->
                                    <span class="outletName" id="outletName">
                                        {{ mention.publication?.name }}<span id="outletNameIcon" class="agpr-mention-link-profile-hoverIcon outletNameIcon fa-kit fa-agpr-outlet-solid"></span>
                                    </span>
                                </ng-template>
                            }
                        }
                    </div>

                    @if (mention.author.name) {
                        <div class="agpr-mention-main-author">
                            <span>{{ mention.isRetweet ? ('Mention.RetweetedBy' | localize) : "" }}</span>
                            <span>{{ mention.isTweetReply ? ('Mention.TweetReply' | localize) : "" }}</span>
                            <span>{{ mention.linkedinData?.type === linkedinTypeEnum.REPOST ? ('Mention.RetweetedBy' | localize) : "" }}</span>
                            @if (isLegacyTargetingUser) {
                                @if (mention.author.contactUrl) {
                                    <a
                                        class="agpr-mention-link"
                                        [id]="id + '.authorLink'"
                                        [href]="mention.author.contactUrl"
                                        target="_blank"
                                    >
                                        <span>{{ mention.author?.name }}</span>
                                    </a>
                                } @else {
                                    <span>{{ mention.author?.name }}</span>
                                }
                            } @else {
                                @if (mention.author?.uuid) {
                                    <agpr-button
                                        class="agpr-mention-link agpr-mention-link-profile"
                                        [id]="id + '.authorLink'"
                                        [style]="buttonTypes.link"
                                        (click)="contactClicked.emit()"
                                        agprTooltip="Mention.tooltip.contact"
                                        tooltipPosition="top"
                                    >
                                        <ng-container [ngTemplateOutlet]="contactName"></ng-container>
                                    </agpr-button>
                                } @else {
                                    <ng-container [ngTemplateOutlet]="contactName"></ng-container>
                                }
                                <ng-template #contactName>
                                    <!-- please do not change the indent here, it would add an empty space -->
                                    <span class="contactName" id="contactName">
                                        @if (mention.mediaType.id === mediaTypes.TWITTER && !mention.author.id) {<span>&#64;</span>}{{ mention.author?.name }}<span id="contactNameIcon" class="agpr-mention-link-profile-hoverIcon contactNameIcon fa-solid fa-user"></span>
                                    </span>
                                </ng-template>
                            }
                        </div>
                    }
                </div>
            </div>

            <div class="agpr-mention-main-iconAndTime">
                <span
                    role="img"
                    class="agpr-mention-mediaTypeIcon"
                    [ngClass]="mention.mediaType.icon"
                    [agprTooltip]="mention.mediaType.tooltip"
                    tooltipPosition="top"
                ></span>
            </div>
        </div>

        <div class="agpr-mention-main-body">
            @if (!_compact && !contentVisible && (mentionContent !== mentionContentTypes.headlineOnly)) {
                <section
                    class="agpr-mention-body"
                    dir="auto"
                    [ngStyle]="{'text-align': bodyTextAlign}"
                >
                    @if (mention?.showTranslated || (mention?.isTranslatedPreferred && mention?.translation)) {
                        <span
                            [innerHTML]="
                                ((mention.useSummaryForDisplay && mentionContent === mentionContentTypes.summary && mention?.translation?.summary )
                                    ? mention?.translation?.summary : mention?.translation?.body)
                                | filterStringByIndex : null : 10 : maxWordCount
                            "
                        ></span>
                    }
                    @if (!mention?.showTranslated && (!mention?.isTranslatedPreferred || !mention?.translation) && mention.useSummaryForDisplay && mentionContent === mentionContentTypes.summary) {
                        <span
                            [innerHTML]=" mention.summary
                                | indexHighlight : mention.summaryContextualKeywordIndices : highlightKeywords
                                | mentionLinks : mention.mediaType.id
                                | indexHighlightSup
                                | filterStringByIndex : mention.summaryContextualKeywordIndices[0] : 10 : maxWordCount
                            "
                        ></span>
                    }
                    @if (!mention?.showTranslated && (!mention?.isTranslatedPreferred || !mention?.translation) && (!mention.useSummaryForDisplay || mentionContent !== mentionContentTypes.summary)) {
                        <span
                            [innerHTML]=" mention.body
                                | indexHighlight : mention.contexualKeywordIndices : highlightKeywords
                                | mentionLinks : mention.mediaType.id
                                | indexHighlightSup
                                | filterStringByIndex : mention.contexualKeywordIndices[0] : 10 : maxWordCount
                            "
                        ></span>
                    }
                </section>
            }
            @if (contentVisible) {
                <section
                    class="agpr-mention-body"
                    dir="auto"
                    [ngStyle]="{'text-align': bodyTextAlign}"
                >
                    @if ((mention?.showTranslated || mention?.isTranslatedPreferred) && mention?.translation?.paragraphs) {
                        @for (paragraph of mention.translation.paragraphs; track $index) {
                            <p
                                class="agpr-mention-paragraph"
                                [innerHTML]="
                                    paragraph
                                        | mentionLinks : mention.mediaType.id
                                        | indexHighlightSup
                                "
                            >
                            </p>
                        }
                    } @else {
                        @for (paragraph of paragraphs; track $index) {
                            <p
                                class="agpr-mention-paragraph"
                                [innerHTML]="
                                    paragraph
                                        | mentionLinks : mention.mediaType.id
                                        | indexHighlightSup
                                "
                            >
                            </p>
                        }
                        @if (mention.isFinancialTimes) {
                            <agpr-financial-times-attribution
                                [mention]="mention"
                            ></agpr-financial-times-attribution>
                        }

                        <agpr-original-tweet
                            [tweetData]="mention.tweetData"
                        ></agpr-original-tweet>
                    }
                </section>
            }
            @if (mention.images && mention.images.length > 0) {
                <section
                    class="agpr-mention-images"
                    [ngClass]="{'agpr-mention-images--hidden': !contentVisible && !_showImages}"
                >
                    <agpr-image-list
                        [images]="mention.images"
                        [showPopover]="_showImages || expanded"
                        [highlightKeywords]="highlightKeywords"
                        (imageLoaded)="_showImages && !contentVisible && updateCollapsedHeight()"
                        [useMentionCardErrorStyle]="useMentionCardErrorTemplate"
                    >
                    </agpr-image-list>
                </section>
            }
        </div>
    </div>

    <div class="agpr-mention-divider"></div>

    <div
        class="agpr-mention-additionalInfo"
        [ngClass]="{'compact': _compact && !contentVisible}"
    >
        <div class="agpr-mention-additionalInfo-expandToggle">
            <span
                role="button"
                class="agpr-mention-additionalInfo-expandToggleIcon fa-solid"
                [ngClass]="{
                    'fa-angle-up': contentVisible,
                    'fa-angle-down': !contentVisible,
                    'agpr-mention-additionalInfo-expandToggleIcon--cannotExpand': !enableExpandToggle
                }"
                [attr.tabindex]="enableExpandToggle ? 0 : -1"
                [attr.aria-expanded]="contentVisible"
                [attr.aria-controls]="id + '_feedContent'"
                (click)="toggleExpanded($event)"
                [agprTooltip]="contentVisible ? 'Mention.collapse.tooltip': 'Mention.expand.tooltip'"
                (keydown)="onKeydown($event)"
                tooltipPosition="left"
            >
            </span>
        </div>

        <div class="agpr-mention-additionalInfo-metadata">

            @if (mention?.syndicateInfo && isSyndicateMode) {
                <div class="agpr-mention-additionalInfo-metadata-label">
                    {{ 'Monitor.syndicates.information' | localize }}
                </div>
                <agpr-meta-data
                    [id]="id"
                    class="agpr-mention-additionalInfo-metadata-item"
                    [icon]="'fa-solid fa-files'"
                    [value]="'Monitor.syndicates.timesValue' | localize:{ count: mention.syndicateInfo.count }"
                    [tooltip]="'Monitor.syndicates.countTooltip' | localize:{ count: mention.syndicateInfo.count }"
                >
                    <div class="agpr-mention-viewAllSyndicates">
                        <agpr-button
                            class="agpr-mention-viewAllSyndicates-button"
                            (click)="viewAllSyndicatesClicked.emit()"
                            [style]="buttonTypes.tertiary"
                        >
                            {{ 'Monitor.syndicates.view' | localize }}
                        </agpr-button>
                    </div>
                </agpr-meta-data>

                <agpr-meta-data
                    [id]="id"
                    class="agpr-mention-additionalInfo-metadata-item"
                    [icon]="'fa-solid fa-calendar-days'"
                    [value]="mention.syndicateInfo.timeLabel"
                    [tooltip]="'Monitor.syndicates.timeTooltip' | localize:{ time: mention.syndicateInfo.timeLabel }"
                ></agpr-meta-data>
                <agpr-meta-data
                    [id]="id"
                    class="agpr-mention-additionalInfo-metadata-item"
                    [icon]="'fa-solid fa-arrows-to-eye'"
                    [value]="mention.syndicateInfo.impressions | number"
                    [tooltip]="'Monitor.syndicates.impressionsTooltip'"
                ></agpr-meta-data>
            } @else if (!isSyndicateMode) {
                @if (preferences) {
                    @let publishedTime = ('Social.postFeed.datePublished' | localize) + (mention?.datePublished | changeTimeZone: preferences.timeZone: dateFormat);
                    @let availableTime = ('Social.postFeed.dateAvailable' | localize) + (mention?.dateAvailable | changeTimeZone: preferences.timeZone: dateFormat);
                    <agpr-meta-data
                        [id]="id"
                        class="agpr-mention-additionalInfo-metadata-item agpr-mention-additionalInfo-metadata-item-date"
                        [icon]="'fa-solid fa-calendar-days'"
                        [value]="(showPublishedDate ? mention.datePublished : mention.dateAvailable) | changeTimeZone: preferences.timeZone: dateFormat"
                        [tooltip]="showPublishedDate ? '<b>' + publishedTime + '</b>\n' + availableTime : publishedTime + '\n<b>' + availableTime + '</b>'"
                        [ariaLabel]="publishedTime + ' ' + availableTime"
                    ></agpr-meta-data>
                }
                @if (showSentimentOnExpanded ? (!_compact || contentVisible) : expanded) {
                    <agpr-meta-data
                        [id]="id"
                        class="agpr-mention-additionalInfo-metadata-item"
                        [type]="attributeTypes.sentiment"
                        [icon]="'fa-solid fa-face-smile'"
                        [value]="mention.sentimentName"
                        [tooltip]="'Mention.details.sentiment'"
                        [infoTooltip]="'Monitoring.sentiment.tooltip'"
                    ></agpr-meta-data>
                }
                @if (!_compact || contentVisible) {
                    <div class="agpr-mention-metadataItem">
                        @switch(metricType) {
                            @case(searchCriteriaSortFieldEnum.domainAuthority) {
                                <agpr-meta-data
                                    [id]="id"
                                    class="agpr-mention-additionalInfo-metadata-item"
                                    [type]="attributeTypes.domainAuthority"
                                    [icon]="'fa-solid fa-gauge-simple-high'"
                                    [value]="mention.domainAuthority"
                                    [tooltip]="'Mention.details.domainAuthority'"
                                    [infoTooltip]="'Mention.details.domainAuthorityTooltip'"
                                ></agpr-meta-data>
                            }
                            @case(searchCriteriaSortFieldEnum.ave) {
                                <agpr-meta-data
                                    [id]="id"
                                    class="agpr-mention-additionalInfo-metadata-item"
                                    [type]="attributeTypes.adValueUsd"
                                    [icon]="'fa-solid fa-circle-dollar'"
                                    [value]="mention.adValueUsd"
                                    [tooltip]="'Mention.details.ave'"
                                    [infoTooltip]="'Mention.details.aveTooltip'"
                                ></agpr-meta-data>
                            }
                            @case(searchCriteriaSortFieldEnum.engagement_total) {
                                @if (mention.mediaType.isSocial) {
                                    <agpr-meta-data
                                        [id]="id"
                                        class="agpr-mention-additionalInfo-metadata-item"
                                        [type]="attributeTypes.engagement"
                                        [icon]="'fa-solid fa-retweet'"
                                        [value]="mention.engagements | number"
                                        [tooltip]="engagementTooltip"
                                        [ariaLabel]="engagementTooltip"
                                    ></agpr-meta-data>
                                }
                            }
                            @case(searchCriteriaSortFieldEnum.engagement_rate) {
                                @if (mention.mediaType.isSocial) {
                                    <agpr-meta-data
                                        [id]="id"
                                        class="agpr-mention-additionalInfo-metadata-item"
                                        [icon]="'fa-solid fa-percent'"
                                        [value]="mention.engagementRate | number: '1.0-2'"
                                        [tooltip]="'Mention.details.engagementRate'"
                                    ></agpr-meta-data>
                                }
                            }
                            <!-- set searchCriteriaSortFieldEnum.audience_reach as default -->
                            @default {
                                <agpr-meta-data
                                    [id]="id"
                                    class="agpr-mention-additionalInfo-metadata-item"
                                    [type]="attributeTypes.audienceReach"
                                    [icon]="'fa-solid fa-arrows-to-eye'"
                                    [value]="mention.audienceReach"
                                    [isSimilarWeb]="mention.isAudienceFromSimilarWeb"
                                    [tooltip]="'Mention.details.audienceReach'"
                                ></agpr-meta-data>
                            }
                        }
                    </div>
                }
            }
        </div>


        <div
            class="agpr-mention-additionalInfo-badges"
            [ngClass]="{'compact': _compact && !contentVisible}"
        >
            <div class="agpr-mention-additionalInfo-badgeContainer first">
                @for (badge of activeBadges; track badge.type) {
                    @if (badge.section === badgeSections.first) {
                        <span
                            role="img"
                            class="agpr-mention-additionalInfo-badge"
                            [ngStyle]="badge.style"
                            [ngClass]="badge.icon"
                            [agprTooltip]="badge.tooltip"
                            tooltipPosition="top"
                        ></span>
                    }
                }
            </div>

            <div class="agpr-mention-additionalInfo-badgeContainer second">
                @for (badge of activeBadges; track badge.type) {
                    @if (badge.section === badgeSections.second) {
                        <span
                            role="img"
                            class="agpr-mention-additionalInfo-badge"
                            [ngStyle]="badge.style"
                            [ngClass]="badge.icon"
                            [agprTooltip]="badge.tooltip"
                            tooltipPosition="top"
                        ></span>
                    }
                }
            </div>
        </div>
    </div>
</article>
